import ItemIDO from "../IDO/itemIDO";
import {
  EmptyLaunchpad,
  IDOLaunchContainer,
  IDOLaunchWrapper,
  IDOList,
} from "../IDO/styled";

const EndedLaunchpad = ({ finishedData, handleClaimReward }: any) => {
  return (
    <IDOLaunchContainer>
      {finishedData?.length > 0 ? (
        <IDOLaunchWrapper>
          <IDOList>
            {finishedData?.map((item: any, index: any) => {
              return (
                <ItemIDO
                  key={index}
                  data={item}
                  onClaimReward={() => {
                    handleClaimReward(item);
                  }}
                />
              );
            })}
          </IDOList>
        </IDOLaunchWrapper>
      ) : (
        <EmptyLaunchpad>
          <figure>
            <img
              width={314}
              height={282}
              src="/assets/images/common/empty_launchpad.png"
              alt="icon"
            />
          </figure>
          <h2>What's Next?</h2>
          <p>
            Our live launchpad is currently empty, but keep an eye out!
            <br /> Amazing projects will be going live soon.
          </p>
        </EmptyLaunchpad>
      )}
    </IDOLaunchContainer>
  );
};

export default EndedLaunchpad;
